import { createFileRoute } from '@tanstack/react-router';
import { parsePaginationSearch } from '../../../features/common/pagination-search';
import { Permission } from '../../../features/common/permision';
import { VideoHistoryPage } from '../../../features/video/video-history.page';

export const Route = createFileRoute('/_creator-center/video/history')({
  staticData: { permissions: [Permission.视频生成] },
  validateSearch: parsePaginationSearch,
  component: VideoHistoryPage,
});
